import * as THREE from "three";
import React, { useRef } from "react";
import { useLoader, useFrame } from "react-three-fiber";
import useStore from "../store";

const Globe = React.forwardRef((prop, ref) => {
  const camera = useStore((state) => state.camera);
  const controls = useStore((state) => state.controls);

  const { globeRadius, enableShadows } = useStore((state) => state.mutation);

  return (
    <mesh ref={ref} receiveShadow={enableShadows}>
      <sphereGeometry attach="geometry" args={[globeRadius, 16, 16]} />
      <meshStandardMaterial
        attach="material"
        color={0x1e4048}
        side={THREE.DoubleSide} // so ray can intersect from origin
      />
    </mesh>
  );
});

export default Globe;
